import React from 'react';
import {
  SelectItem,
  SelectItemTemplate,
  SelectValueTemplate,
  SelectViewProps
} from '../../../components/forms/Select/Select.view';
import classNames from 'classnames';
import selectClasses from '../../../components/forms/Select/Select.module.scss';
import classes from './Categories.module.scss';
import { CategoryColor, CategoryFieldsFragment, PostQueueCountResult } from '../../../models/graphql';
import { ListItem } from '../../../components/actions/ListItem';
import { FormElementValueType } from '../../../models/basic-objects';

export type MappedCategoriesType = Omit<CategoryFieldsFragment, '__typename'>;
export const getCategorySelectTemplates = (
  categories: MappedCategoriesType[]
): [SelectValueTemplate, SelectItemTemplate] => {
  const getCategoryLabel = (id: FormElementValueType): string => {
    const item = categories.find(i => i.id === id);
    return item?.name || 'Select a Category';
  };

  const getCategoryColor = (id: FormElementValueType): CategoryColor => {
    const defaultColor = CategoryColor.LIGHT_GREY;
    const color: CategoryColor | undefined = categories.find((item: MappedCategoriesType) => {
      return item && item.id === id;
    })?.color;
    return color || defaultColor;
  };

  const categoryValueTemplate: SelectValueTemplate = (props: SelectViewProps, globalClasses: string) => {
    const categoryColor = getCategoryColor(props.selectedValue); //categoryId
    const categoryLabel = getCategoryLabel(props.selectedValue); //categoryId
    const categoryClass = classNames({
      [selectClasses.ColorLabel]: true,
      [classes[`CategoryBackgroundColor${categoryColor}`]]: true
    });
    const overrideGlobalClasses = classNames(globalClasses, selectClasses.CategoryTemplate);
    return (
      <div className={overrideGlobalClasses}>
        <div className={categoryClass}>
          <span className={'show-for-sr'}>{props.selectedValue}</span>
        </div>
        {categoryLabel}
      </div>
    );
  };

  const itemTemplate: SelectItemTemplate = (props: SelectViewProps, index: number, item: SelectItem) => {
    const categoryColor = getCategoryColor(item.value);
    const categoryClass = classNames({
      [selectClasses.ListItemColor]: true,
      [classes[`CategoryBackgroundColor${categoryColor}`]]: true
    });

    return (
      <ListItem
        key={index}
        role={'option'}
        aria-label={item.label}
        variation={'regular'}
        type={'li'}
        selected={item.value === props.selectedValue}
        action={e => {
          props.updateValue(item.value);
          e?.stopPropagation();
        }}
        disabled={false}>
        <div className={selectClasses.ListItem}>
          <div className={categoryClass}>
            <span className={'show-for-sr'}>{item.value}</span>
          </div>
          {item.label}
        </div>
      </ListItem>
    );
  };

  return [categoryValueTemplate, itemTemplate];
};

export const getCategoryQueueCounts = (queueCounts: PostQueueCountResult) => {
  const counts: Record<string | number, number | undefined> = {};

  for (const item of queueCounts.categories) {
    const key = item.categoryId;
    counts[key] = item.count;
  }

  return counts;
};
